import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';
import { useTheme } from 'styled-components';

import commonMessages from '~/core/commonMessages';
import { GoalIcon } from '~/core/customIcons';

import { GameCenterTeam, Play as PlayType, PlayByPlayGame } from '../../../../types';

import { GoalTeam } from './components/GoalTeam';

import {
    BackgroundTeam,
    GoalAndTeam,
    GoalContainer,
    GoalDescription,
    GoalGlow,
    GoalIconContainer,
    GoalValue,
} from './styles';

type Props = {
    game: PlayByPlayGame;
    play: PlayType;
    scoringTeam: GameCenterTeam;
};

const Goal: FC<Props> = ({ game, play, scoringTeam }) => {
    const theme = useTheme();
    const backgroundColor =
        (scoringTeam.abbrev && theme.Team[scoringTeam.abbrev]?.gamecenter) || theme.Surface.Opposite.tertiary;

    return (
        <GoalContainer $teamAbbrev={scoringTeam.abbrev}>
            {scoringTeam.id === game.awayTeam.id && (
                <BackgroundTeam>
                    <GoalTeam team={scoringTeam} backgroundColor={backgroundColor} />
                </BackgroundTeam>
            )}
            <GoalTeam
                team={game.awayTeam}
                isSmall
                isFaded={scoringTeam.id !== game.awayTeam.id}
                backgroundColor={backgroundColor}
            />
            <GoalValue $teamAbbrev={scoringTeam.abbrev} $isScoringTeam={scoringTeam.id === game.awayTeam.id}>
                {play?.details?.awayScore}
            </GoalValue>
            <GoalDescription>
                <GoalIconContainer>
                    <GoalIcon />
                    <GoalGlow />
                </GoalIconContainer>
                <GoalAndTeam $teamAbbrev={scoringTeam.abbrev}>
                    <FormattedMessage
                        description="A phrase describing the team a goal was scored by, (Ex: BUF GOAL)"
                        defaultMessage="{scoringTeam} {goalMessage}"
                        values={{
                            goalMessage: <FormattedMessage {...commonMessages.eventDescriptions.goal} />,
                            scoringTeam: scoringTeam.abbrev,
                        }}
                    />
                </GoalAndTeam>
            </GoalDescription>
            <GoalValue $teamAbbrev={scoringTeam.abbrev} $isScoringTeam={scoringTeam.id === game.homeTeam.id}>
                {play?.details?.homeScore}
            </GoalValue>
            <GoalTeam
                team={game.homeTeam}
                isSmall
                isFaded={scoringTeam.id !== game.homeTeam.id}
                backgroundColor={backgroundColor}
            />
            {scoringTeam.id === game.homeTeam.id && (
                <BackgroundTeam $isRight>
                    <GoalTeam team={scoringTeam} backgroundColor={backgroundColor} />
                </BackgroundTeam>
            )}
        </GoalContainer>
    );
};

export default Goal;
